<template>
<v-dialog
    v-model="dialog"
    max-width="600"
    persistent
>
    <v-card>
    <v-card-title class="headline">Accept Agreement(s)</v-card-title>

    <v-card-text
        v-if="check != null"
    >
        
           <m-sign-packet
                agreement_type="accept-above-agreements"
                :organization_id="$rc.$state.getOrganizationId()"
                :meta_data="meta_data"
                v-model="is_signed"
                ref="sign-packet-dialog"
           />

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>
        
        <v-btn
            text
            @click="onSignOut"
        >
        I do not agree
        </v-btn>
       
        <v-btn
            color="primary darken-1"
            text
            @click="onSign"
            :disabled="!is_signed"
        >
        Agree
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

export default {


    data() {
        return {
            dialog: false,
            check: null,
            meta_data: [],
            is_signed: false,
            employee_id: null,
        }
    },

    methods: {

        showDialog(employee_id) 
        {
            if ( this.$rc.$state.isAuthActorSystemAdmin() && this.$rc.$state.isActingAsSomoneElse() )
            {
                // Don't ask a system admin to sign for someone else...
                return;
            }

            this.dialog = true;
            this.is_signed = false;
            this.employee_id = employee_id;

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/eula/signatures/:employee_id',
            
                'params' : {
                        'employee_id': employee_id,
                    },
            
                'on_success': (check) => {
                        this.check = check;
                        this.getBlobMetaData();
                    },
            
                'on_error': 'Unable to get signature'
            });
        },

        getBlobMetaData()
        {
            if ( this.check == null ) return;

            this.$rc.showSpinner();

            this.$rc.getBlobMetaDataMultiple(
                this.check.current_packet.blob_ids,

                (data) => {
                    this.$rc.hideSpinner();
                    this.meta_data = data.meta_data;
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error', 'Unable to get blob meta data');
                }
            )
        },
        
        onSign()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/signatures/sign-agreement',
            
                'params' : {
                        'packet_id': this.check.current_packet.packet_id,
                        'signed_by_employee_id': this.$rc.$state.getEmployeeId(),
                        'agreement_specimen': '[X] '+this.$refs['sign-packet-dialog'].getSpecimen(),
                    },
            
                'on_success': (data) => {
                        this.dialog = false;
                    },
            
                'on_error': 'Unable to sign agreement(s)',
            });            
        },

        onSignOut()
        {
            this.dialog = false;

            this.$rc.alert(
                'Agreement Declined', 
                'Until you agree to the agreements, you may not use the software.  You will now be signed out.<br/><br/>If you change your mind later, you may sign in again to accept the agreement.',

                () => {
                    this.$rc.signOut();
                    this.$router.push({'name': 'sign-in'}).catch(e=>{}); // swallow any exception
                }
            );
        }
    },
}
</script>

<style lang="scss" scoped>

</style>